
import React, {useState, useContext } from 'react';
import { useLocation } from "react-router-dom";
import { UserContext } from '../../UserContext.js';

import styles from './ReviewSubscriptionScreen.module.css';
import helpers from '../../helpers.js';

import ScreenHeader from "../ScreenHeader.js";
import Module from "../Module.js";
import Button from "../Button.js";
import TextInput from "../TextInput.js";
import TermsAndConditions from "./TermsAndConditions.js";


//TODO ROUNDING
//ADDRESS LINE 2?? BUSINESSNAME

function ReviewSubscriptionScreen(props) {
  const {user, setUser} = useContext(UserContext);
  const [formData, setFormData] = useState({
    ...useLocation().state.formData,
    farmerComments: ""
  });
  const [deliveryDetails, setDeliveryDetails] = useState(useLocation().state.addresses.deliveryDetails);
  const [billingDetails, setBillingDetails] = useState(useLocation().state.addresses.billingDetails);
  console.log(useLocation().state.addresses);
  const [addresses, setAddresses] = useState(useLocation().state.addresses);

  const [displayOverlay, setDisplayOverlay] = useState(false);
   const [errorPrompt, setErrorPrompt] = useState("");


  const getIpAddress = async () => {
    const res = await fetch('https://api.ipify.org?format=json');
    const data = await res.json();
    return data.ip;
  };

  const getDeviceInfo = () => {
    return `${navigator.platform} | ${navigator.userAgent}`;
  };

  const handleSubmit = async () => {
    if(true){ //FORM VALIDATION HERE
       const ip = await getIpAddress();
      const device = getDeviceInfo();

      const submissionPayload = {
        ...formData,
        ipAddress: ip,
        deviceSignature: device,
        paymentPlan: "upfront"
      };
        const request = {
            method: "put",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: "Bearer " + user.token,
            },
            body: JSON.stringify(submissionPayload),
          };
      
          let response = await fetch(user.backEndURL + "/update-subscription", request);
          let jsonResponse = await response.json();
          if (jsonResponse.success) {
            props.goToScreen("confirm-subscription")
          }else {
            // helpers.errorPrompt("Oops something went wrong while updating...", null, setPrompt, null)
          }
    } else {
        // helpers.errorPrompt("Passwords do not match!", "password2", setPrompt, setHighlighedtInput)
    }
    return;
  };
  
  const goToUpdateDeliveryDetails = () => {
    console.log("SENDING deliveryDetails");

    props.goToScreen("update-delivery-details", {
    deliveryDetails: deliveryDetails,
    billingDetails: billingDetails,
    formDataCheckout: formData,
    // setAddresses: (newDeliveryDetails) => {
    //   const updated = {
    //     ...addresses,
    //     deliveryDetails: newDeliveryDetails
    //   };
    //   setAddresses(updated);
    // }
    });
  };

  const goToUpdateBillingDetails = () => {
    console.log("SENDING billingDetails");
    props.goToScreen("update-billing-details", {
      deliveryDetails: deliveryDetails,
      billingDetails: billingDetails,
      formDataCheckout: formData,
      // setAddresses: (newBillingDetails) => {

    })
  }

  const detailsValid = (details) => {
    if(details.email ===  "" || details.firstName === "" || details.lastName === "" || details.phone === "" || details.addressLine1 === "" || details.zip === "") {
      return false;
    } else {
      return true;
    }
  }



  const handleChange = (formField, value) => {
    setFormData({ ...formData, [formField]: value });
  };


  const calculatePlanDiscount = () => {
    console.log("PLAN: " + formData.plan);
    switch(formData.plan) {
      case "individual":
        return 0;
      case "oneYear":
        return(formData.pincharBags * 200 + formData.pelletcharBags * 200);
      case "twoYears":
        return(formData.pincharBags * 300 + formData.pelletcharBags * 300);
      default:
        return 0;
    }
  }

  return (
    <>
      <div className={helpers.clx(styles.overlayContainer, displayOverlay ? styles.overlayContainerDisplay : "")}>
        <TermsAndConditions handleSubmit={handleSubmit} handleChange={handleChange}setDisplayOverlay={setDisplayOverlay} formData={formData} />
      </div>
      <div className={helpers.clx("mainWhiteContainerContent", props.screenTransitioning ? "mainWhiteContainerContentHidden" : "")}>
          <ScreenHeader name={"Bulk Biochar Purchase"} content={"Ready to order? Get your biochar in just three steps: Choose how many bags you need, select a plan, and set up your payment."}/>
          <div className={"contentGrid"}>
            <Module name={"Order Summary"} spanColumn={24} spanRow={1} height={"100%"}>
              <div className={styles.reviewDescription}>
              Please review the details of your order request to make sure the information is accurate and up to date. 
              </div>
              <div className={styles.contentContainer}>
                <div className={styles.column}>
                    <div className={styles.reviewModule}>
                      <div className={styles.moduleHeader}>
                        Purchase Overview
                      </div>
                      <div className={styles.overviewRow}>
                        <div className={styles.contentSection}>
                          <div className={styles.contentHeader}>
                            PinChar<br/>
                          </div>
                          <div className={styles.contentRow}>
                            <span className={styles.icon}>shopping-bag</span> {formData.pincharBags} 
                          </div>
                          <div className={styles.contentRow}>
                            <span className={styles.icon}>cube</span> {Math.round(10 * (formData.pincharBags * 1.9 + formData.pelletcharBags * 1.9)) / 10} m<span className={styles.exp}>3</span> 
                          </div>
                          <div className={styles.contentRow}>
                            <div className={styles.icon}>balance-scale</div> ~ {Math.round(10 * (formData.pincharBags * 30 + formData.pelletcharBags * 30)) / 1000} t 
                          </div>
                        </div>
                        <div style={{opacity: 0.4}} className={styles.contentSection}>
                          <div className={styles.contentHeader}>
                            PelletChar<br/>
                          </div>
                          <div className={styles.contentRow}>
                            <span className={styles.icon}>shopping-bag</span> {formData.pelletcharBags} 
                          </div>
                          <div className={styles.contentRow}>
                            <span className={styles.icon}>cube</span> {Math.round(helpers.estimateBiocharStats(formData.pincharBags, formData.pelletcharBags, formData.billingPlan).volumePelletchar)} m<span className={styles.exp}>3</span> 
                          </div>
                          <div className={styles.contentRow}>
                            <div className={styles.icon}>balance-scale</div> {Math.round(helpers.estimateBiocharStats(formData.pincharBags, formData.pelletcharBags, formData.billingPlan).weightPelletchar)} t 
                          </div>
                        </div>
                        <div className={styles.contentSection}>
                          <div className={styles.contentHeader}>
                            Total Price (EXW + VAT) <br/>
                          </div>
                          <div className={helpers.clx(styles.contentRow, styles.contentBold)}>
                            £ {((formData.pelletcharBags * 599 + formData.pincharBags * 599) - calculatePlanDiscount()  - formData.voucherDiscount).toFixed(2) }
                          </div>
                        </div>
                        <div className={styles.contentSection}>
                          <div className={styles.contentHeader}>
                            Billing<br/>
                          </div>
                          <div className={helpers.clx(styles.contentRow, styles.contentBold)}>
                            n/a{/* £ 0Math.round(helpers.estimateBiocharStats(formData.pincharBags, formData.pelletcharBags, formData.billingPlan).priceTotal / 12) / month */}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={styles.reviewModule}>
                      <div className={styles.editDetailsIconContainer} onClick={goToUpdateDeliveryDetails}>
                          <div className={styles.iconEdit}>pencil</div> 
                        </div>
                      <div className={styles.moduleHeader}>
                        Delivery Details
                      </div>
                      <div className={styles.overviewRow}>
                        <div className={helpers.clx(styles.contentSection, styles.contentDelivery1)}>
                          <div className={styles.contentHeader}>
                            Contact<br/>
                          </div>
                          <div className={helpers.clx(styles.contentRow, styles.contentRegular)}>
                            {addresses.deliveryDetails.firstName} {addresses.deliveryDetails.lastName}<br/>
                            {addresses.deliveryDetails.email}<br/>
                            {addresses.deliveryDetails.phone}
                          </div>
                        </div>
                        <div className={helpers.clx(styles.contentSection, styles.contentDelivery1)}>
                          <div className={styles.contentHeader}>
                            Delivery Address<br/>
                          </div>
                          <div className={helpers.clx(styles.contentRow, styles.contentRegular)}>
                          {addresses.deliveryDetails.businessName}<br/>
                          {addresses.deliveryDetails.addressLine1}<br/>
                          {addresses.deliveryDetails.addressLine2}<br/>
                          {addresses.deliveryDetails.city}<br/>

                          {addresses.deliveryDetails.county}<br/>
                          {addresses.deliveryDetails.zip}

                          </div>
                        </div>
                      </div>
                      <div className={styles.overviewRow}>
                        <div className={helpers.clx(styles.contentSection, styles.contentDelivery2)}>
                          <div className={styles.contentHeader}>
                            Delivery Instructions<br/>
                          </div>
                          <div className={helpers.clx(styles.contentRow, styles.contentRegular)}>
                          {addresses.deliveryDetails.instructions}
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
                <div className={styles.column}>
                {/* <div className={styles.reviewModule}>
                      <div className={styles.moduleHeader}>
                        Scheduled Deliveries
                      </div>
                      <div className={styles.overviewRow}>
                        <div className={helpers.clx(styles.contentSection, styles.contentDelivery1)}>
                          <div className={styles.contentHeader}>
                            Delivery 1<br/>
                          </div>
                          <div className={helpers.clx(styles.contentRow, styles.contentRegular)}>
                            Week of: <span className={helpers.clx(styles.contentBold, styles.contentBoldDeliveries)}>TBC</span><br/>
                          </div>
                          <div className={helpers.clx(styles.contentRow, styles.contentRegular)}>
                            PinChar: <span className={helpers.clx(styles.contentBold, styles.contentBoldDeliveries)}>TBC</span><br/>
                          </div>
                          <div className={helpers.clx(styles.contentRow, styles.contentRegular)}>
                            PelletChar: <span className={helpers.clx(styles.contentBold, styles.contentBoldDeliveries)}>{Math.round(formData.pelletcharBags/4)} bags</span><br/>
                          </div>
                        </div>
                        {/* <div className={helpers.clx(styles.contentSection, styles.contentDelivery1)}>
                          <div className={styles.contentHeader}>
                            Delivery 2<br/>
                          </div>
                          <div className={helpers.clx(styles.contentRow, styles.contentRegular)}>
                            Week of: <span className={helpers.clx(styles.contentBold, styles.contentBoldDeliveries)}>17/10/22</span><br/>
                          </div>
                          <div className={helpers.clx(styles.contentRow, styles.contentRegular)}>
                            PinChar: <span className={helpers.clx(styles.contentBold, styles.contentBoldDeliveries)}>{Math.round(formData.pincharBags/4)} bags</span><br/>
                          </div>
                          <div className={helpers.clx(styles.contentRow, styles.contentRegular)}>
                            PelletChar: <span className={helpers.clx(styles.contentBold, styles.contentBoldDeliveries)}>{Math.round(formData.pelletcharBags/4)} bags</span><br/>
                          </div>
                        </div> 
                      </div>
                      <div className={styles.overviewRow}>
                      <div className={helpers.clx(styles.contentSection, styles.contentDelivery1)}>
                          {/* <div className={styles.contentHeader}>
                            Delivery 3<br/>
                          </div>
                          <div className={helpers.clx(styles.contentRow, styles.contentRegular)}>
                            Week of: <span className={helpers.clx(styles.contentBold, styles.contentBoldDeliveries)}>02/02/23</span><br/>
                          </div>
                          <div className={helpers.clx(styles.contentRow, styles.contentRegular)}>
                            PinChar: <span className={helpers.clx(styles.contentBold, styles.contentBoldDeliveries)}>{Math.round(formData.pincharBags/4)} bags</span><br/>
                          </div>
                          <div className={helpers.clx(styles.contentRow, styles.contentRegular)}>
                            PelletChar: <span className={helpers.clx(styles.contentBold, styles.contentBoldDeliveries)}>{Math.round(formData.pelletcharBags/4)} bags</span><br/>
                          </div>
                        </div>
                        <div className={helpers.clx(styles.contentSection, styles.contentDelivery1)}>
                          <div className={styles.contentHeader}>
                            Delivery 4<br/>
                          </div>
                          <div className={helpers.clx(styles.contentRow, styles.contentRegular)}>
                            Week of: <span className={helpers.clx(styles.contentBold, styles.contentBoldDeliveries)}>11/07/23</span><br/>
                          </div>
                          <div className={helpers.clx(styles.contentRow, styles.contentRegular)}>
                            PinChar: <span className={helpers.clx(styles.contentBold, styles.contentBoldDeliveries)}>{Math.round(formData.pincharBags/4)} bags</span><br/>
                          </div>
                          <div className={helpers.clx(styles.contentRow, styles.contentRegular)}>
                            PelletChar: <span className={helpers.clx(styles.contentBold, styles.contentBoldDeliveries)}>{Math.round(formData.pelletcharBags/4)} bags</span><br/>
                          </div> 
                        </div>
                      </div>
                    </div> */}
                    <div className={helpers.clx(styles.reviewModule, styles.additionalNotesModule)}>
                      <div className={styles.moduleHeader}>
                        Additional Notes
                      </div>
                      <div className={styles.overviewRow}>
                      
                        <TextInput
                          name={"Comments/  Details / Instructions"} 
                          placeholder={"Add any delivery notes, preferences, or additional information here..."} 
                          value={formData.farmerComments} 
                          onChange={(value) => handleChange("farmerComments", value)} 
                          labelStyle={"top"} 
                          height={"7rem"}
                        />
                      </div>
                    </div>
          
                    <div className={styles.reviewModule}>
                       <div className={styles.editDetailsIconContainer} onClick={goToUpdateBillingDetails}>
                          <div className={styles.iconEdit}>pencil</div> 
                        </div>
                      <div className={styles.moduleHeader}>
                        Billing Details
                      </div>
                      <div className={styles.overviewRow}>
                        <div className={helpers.clx(styles.contentSection, styles.contentDelivery1)}>
                          <div className={styles.contentHeader}>
                            Contact<br/>
                          </div>
                          <div className={helpers.clx(styles.contentRow, styles.contentRegular)}>
                            {addresses.billingDetails.firstName} {addresses.billingDetails.lastName}<br/>
                            {addresses.billingDetails.email}<br/>
                            {addresses.billingDetails.phone}
                          </div>
                        </div>
                        <div className={helpers.clx(styles.contentSection, styles.contentDelivery1)}>
                          <div className={styles.contentHeader}>
                            Billing Address<br/>
                          </div>
                          <div className={helpers.clx(styles.contentRow, styles.contentRegular)}>
                            {addresses.billingDetails.businessName}<br/>
                            {addresses.billingDetails.addressLine1}<br/>
                            {addresses.billingDetails.addressLine2}<br/>
                            {addresses.billingDetails.city}<br/>
                            {addresses.billingDetails.county}<br/>
                            {addresses.billingDetails.zip}
                          </div>
                        </div>  
                      </div>
                      <div className={styles.overviewRow}>
                        <div className={helpers.clx(styles.contentSection, styles.contentDelivery2)}>
                          <div className={styles.contentHeader}>
                            VAT Number<br/>
                          </div>
                          <div className={helpers.clx(styles.contentRow, styles.contentRegular)}>
                          {addresses.billingDetails.vat}
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
                
              </div>
              <div className={styles.buttonRow}>
                <Button onPress={() => props.goToScreen("update-subscription", {formData: formData, addresses: addresses})} name="Back" color="Error"/>
                <Button onPress={detailsValid(deliveryDetails) && detailsValid(billingDetails) ? () => setDisplayOverlay(true) : () => helpers.errorPrompt("Please fill in delivery and billing details.", null, setErrorPrompt, null)} name="Submit Order Request" color="Grass"/>
              </div>
                  <div className={helpers.clx("errorPrompt", styles.errorPromptContainer)}>
                    {errorPrompt}
                </div>
            </Module>
          </div>
      </div>
    </>
  );
}

export default React.memo(ReviewSubscriptionScreen);
